import comp from "./LearningCourseDiffSyncStatus";
export default comp;
